import * as CSS from 'csstype';

type GetLanguage = () => string;

type ChangeLanguage = (lang: string) => void;
interface Options {
  btnStyle?: CSS.Properties;
}
const storeKey = 'ssc-transify-switch';
const openLang = 'ssc-transify';

export function getShowKey(): boolean {
  try {
    // chrome关闭第三方cookie功能或者其他浏览器安全配置高时，使用localStorage会报错
    return !!localStorage.getItem(storeKey);
  } catch (error) {
    // 不支持 localStorage 等不报错
    // console.error(error);
    return false;
  }
}

export function useSSCTransify(
  changeLanguage: ChangeLanguage,
  getLanguage: GetLanguage,
  options?: Options,
): void {
  let storeData = '';
  try {
    // chrome关闭第三方cookie功能或者其他浏览器安全配置高时，使用localStorage会报错
    storeData = localStorage.getItem(storeKey) || '';
  } catch (error) {
    // 不支持 localStorage 等不报错
    // console.error(error);
    return;
  }

  // 在页面生成开关
  // 绑定监听事件
  // 获取开关状态
  // 开启开关，设置状态和历史语言
  // 关闭开关，清除状态

  const dom = createButton(storeData, options);
  dom.addEventListener('click', () => {
    const openTag = localStorage.getItem(storeKey);
    if (openTag) {
      // 关闭开关
      changeLanguage(openTag);
      localStorage.removeItem(storeKey);
      setButtonStyle(dom);
    } else {
      // 打开开关
      const lang = getLanguage();
      changeLanguage(openLang);
      localStorage.setItem(storeKey, lang);
      setButtonStyle(dom, lang);
    }
  });
}

function createButton(storeData: string, options?: Options) {
  const dom = document.createElement('button');
  const { btnStyle } = options || {};
  const style: any = {
    position: 'fixed',
    zIndex: '10000',
    right: '4px',
    top: '100px',
    padding: '2px 8px',
    border: 0,
    borderRadius: '4px',
    color: '#fff',
    ...(btnStyle || {}),
  };
  dom.setAttribute(
    'style',
    Object.keys(style)
      .map((key) => `${key}:${style[key]}`)
      .join(';'),
  );

  setButtonStyle(dom, storeData);

  document.body.appendChild(dom);
  return dom;
}

function setButtonStyle(dom: any, lang?: string) {
  dom.innerText = lang ? `Show ${lang}` : 'Show Key';
  dom.style.backgroundColor = lang ? '#55CC77' : '#EE4D2D';
}
